import { z } from 'zod'

export const ADMINDESKTOPAGENTSPOSTACTIONS_CONTRACT_VERSION = '1.0.0' as const
export const adminDesktopAgentsPostActionsResponseSchema = z.unknown()
export type AdminDesktopAgentsPostActionsResponse = z.infer<typeof adminDesktopAgentsPostActionsResponseSchema>
